import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { buildApiUrl, secureFetch } from "@/lib/queryClient";

interface NotificationsContextType {
  unreadCount: number;
  refreshUnreadCount: () => Promise<void>;
}

const NotificationsContext = createContext<NotificationsContextType>({
  unreadCount: 0,
  refreshUnreadCount: async () => {},
});

export function NotificationsProvider({ children }: { children: React.ReactNode }) {
  const [unreadCount, setUnreadCount] = useState(0);

  const refreshUnreadCount = useCallback(async () => {
    try {
      const response = await secureFetch(buildApiUrl('/api/notifications'), {
        credentials: 'include',
      });
      if (response.ok) {
        const notifications = await response.json();
        const count = Array.isArray(notifications)
          ? notifications.filter((n: any) => !n.read).length
          : 0;
        setUnreadCount(count);
      }
    } catch (error) {
      // Silent fail for badge count
    }
  }, []);

  useEffect(() => {
    refreshUnreadCount();
  }, [refreshUnreadCount]);

  return (
    <NotificationsContext.Provider value={{ unreadCount, refreshUnreadCount }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationsContext);
}
